import React from 'react'
import { List } from 'antd'
import { Withdrawal } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { getFormatedPrice } from 'src/core/helpers'
import { CustomText, CustomLink } from 'src/components'

const WithdrawalDetails: React.FC<{ withdrawal: Withdrawal }> = ({ withdrawal }) => {
  const { t } = useTranslation()
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === withdrawal.currency_token_id)?.code

  const items = {
    paypal: [
      { label1: t('Withdrawals.Email'), label2: withdrawal.to_email },
      { label1: t('Projects.Currency'), label2: currencyCode },
      { label1: t('Deposits.Amount'), label2: getFormatedPrice(withdrawal.amount, currencyCode) },
      { label1: t('Summary.AccountCertificate'), label2: withdrawal.cancellation_certificate, isLink: true },
      { label1: t('Summary.PartnershipInvoice'), label2: withdrawal.partnership_invoice, isLink: true },
    ],
    bank: [
      { label1: t('Deposits.IBAN'), label2: withdrawal.iban },
      { label1: t('Summary.AccountNumber'), label2: withdrawal.account_number },
      { label1: t('Deposits.SWIFT'), label2: withdrawal.swift },
      { label1: t('Deposits.BeneficiaryName'), label2: withdrawal.name },
      { label1: t('Projects.Currency'), label2: currencyCode },
      { label1: t('Deposits.Amount'), label2: getFormatedPrice(withdrawal.amount, currencyCode) },
      { label1: t('Summary.BankName'), label2: withdrawal.bank_name },
      { label1: t('Summary.BankAddress'), label2: withdrawal.bank_address },
      { label1: t('Summary.RoutingNumber'), label2: withdrawal.routing_number },
      { label1: t('Summary.AccountCertificate'), label2: withdrawal.cancellation_certificate, isLink: true },
      { label1: t('Summary.PartnershipInvoice'), label2: withdrawal.partnership_invoice, isLink: true },
    ]
  }[withdrawal.kind]

  return (
    <List dataSource={items}
      renderItem={item => (
        <List.Item>
          <React.Fragment>
            <CustomText label={item.label1} type='secondary' />
            {item.isLink ? (
              <CustomLink
                isSmallText
                showIcon={false}
                link={item.label2 || '#'}
                label={item.label2 ? t('general.ClickHere') : '-'}
              />
            ) : (
              <CustomText
                label={item.label2 || '-'}
                type={null}
              />
            )}
          </React.Fragment>
        </List.Item>
      )}
    />
  )
}

export default WithdrawalDetails
